module.exports = __webpack_public_path__ + "static/selune-DND3_FnP-e72109b990db26f8d87458b189dccd24.webp";